import { render, staticRenderFns } from "./OrganizationOverview.vue?vue&type=template&id=09346d86&scoped=true&lang=pug&"
import script from "./OrganizationOverview.vue?vue&type=script&lang=js&"
export * from "./OrganizationOverview.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationOverview.vue?vue&type=style&index=0&id=09346d86&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09346d86",
  null
  
)

export default component.exports